<template>
  <div class="m-wrap m-wap">
    <Logo :extras="extras" />
    <Banner :extras="extras" />
    <div v-if="preview || formInfo.status == 1" class="venue">
      <a
        @click="togoVerify"
        class="goto-venue"
        v-show="
          extraItem.extras('signupfont.display') == 1 &&
          formInfo.moduleType == '2' &&
          whereform == 'webinar'
        "
        :style="{
          color: extraItem.extras('themecolor.bgcolor')
            ? extraItem.extras('themecolor.bgcolor')
            : '#1665D8',
        }"
      >
        {{ extras | extra("signupfont.model") }}
      </a>
      <a
        @click="togoVerify"
        class="goto-venue"
        v-show="
          extraItem.extras('verifyfont.display') == 1 &&
          formInfo.instanceId &&
          formInfo.moduleType != 1 &&
          !(formInfo.moduleType == '2' && whereform == 'webinar')
        "
      >
        {{ extras | extra("verifyfont.model") }}
      </a>
    </div>
    <!--<div class="logo">-->
    <!--<img src="../../assets/images/wap/logo.png" alt="" />-->
    <!--</div>-->
    <!--<div class="banner">-->
    <!--<img src="../../assets/images/wap/banner.png" alt="" />-->
    <!--</div>-->
    <div v-if="preview || formInfo.status == 1">
      <h4
        class="title"
        :style="{
          color: extraItem.extras('titlefont.color'),
          fontSize: pxOrVw(extraItem.extras('titlefont.size')),
          fontWeight:
            extraItem.extras('titlefont.weight') == 'default'
              ? '500'
              : extraItem.extras('titlefont.weight'),
        }"
      >
        {{ formInfo.title }}
      </h4>
      <CField
        class="field-wrap"
        :formData="formData"
        :platform="platform"
        :extras="extras"
      />
      <div class="bottom">
        <a-button
          class="submit ant-btn-primary-default"
          @click="submit()"
          :disabled="isSubmitting"
          :style="{
            backgroundColor:
              extraItem.extras('themecolor.bgcolor') === '#1665D8' &&
              extraItem.extras('submitfont.bgcolor')
                ? extraItem.extras('submitfont.bgcolor')
                : extraItem.extras('themecolor.bgcolor'),
            color: extraItem.extras('submitfont.color'),
          }"
        >
          {{ extras | extra("submitfont.model") }}
        </a-button>
      </div>
    </div>

    <FormStatus
      v-else
      :status="formInfo.status == 0 ? 'nostart' : 'over'"
      :platform="platform"
    ></FormStatus>
    <Card :tenantId="tenantId"></Card>
  </div>
</template>

<script>
import Logo from "@/components/Logo.vue";
import Banner from "@/components/Banner.vue";
import CField from "@/components/CField.vue";
import FormStatus from "@/components/FormStatus.vue";
import mixinConfig from "../../mixin/config.js";
import mixin from "../../mixin/form.js";
import Card from "../../../stempcore/src/core/components/common/Card";
export default {
  name: "WapIndex",
  mixins: [mixinConfig, mixin],
  components: {
    Logo,
    Banner,
    CField,
    FormStatus,
    Card,
  },
  data() {
    return {
      platform: "wap",
    };
  },
};
</script>
